const breadCrumb = "Certificado de Conclusão - Emissão de Certificado";

const routes = [
  {
    path: "/manutencao-registro-certificado-geja",
    name: "manutencao-registro-certificado-geja",
    meta: {
      allowedPermissions: ["parametro_certificado_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoRegistroCertificadoGEJA/ManutencaoRegistroCertificadoGEJAHome.vue"
      ),
  },
  {
    path: "/manutencao-registro-certificado-geja/novo/:solicitacao_id/:aluno_id",
    name: "manutencao-registro-certificado-geja-novo",
    meta: {
      allowedPermissions: ["parametro_certificado_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoRegistroCertificadoGEJA/ManutencaoRegistroCertificadoGEJARegistrar.vue"
      ),
  },
  {
    path: "/manutencao-registro-certificado-geja/alterar/:solicitacao_id/:aluno_id",
    name: "manutencao-registro-certificado-geja-alterar",
    meta: {
      allowedPermissions: ["parametro_certificado_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoRegistroCertificadoGEJA/ManutencaoRegistroCertificadoGEJAAlterar.vue"
      ),
  },
  {
    path: "/manutencao-registro-certificado-geja/cancelar/:solicitacao_id/:aluno_id",
    name: "manutencao-registro-certificado-geja-cancelar",
    meta: {
      allowedPermissions: ["parametro_certificado_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoRegistroCertificadoGEJA/ManutencaoRegistroCertificadoGEJACancelar.vue"
      ),
  },
  {
    path: "/manutencao-registro-certificado-geja/consultar/:solicitacao_id/:aluno_id",
    name: "manutencao-registro-certificado-geja-consultar",
    meta: {
      allowedPermissions: ["parametro_certificado_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoRegistroCertificadoGEJA/ManutencaoRegistroCertificadoGEJAConsultar.vue"
      ),
  },
];

export default routes;
